var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 0.5C6.86125 0.5 6.25625 0.980649 5.885 1.70849C6.50375 2.45006 6.875 3.46629 6.875 4.63358C6.875 5.03184 6.83375 5.38889 6.75125 5.74594C7.0125 5.897 7.27375 6.00687 7.5625 6.00687C8.70375 6.00687 9.625 4.77091 9.625 3.2603C9.625 1.74969 8.70375 0.513733 7.5625 0.513733V0.5ZM3.4375 1.87328C2.29625 1.87328 1.375 3.10924 1.375 4.61985C1.375 6.13046 2.29625 7.36642 3.4375 7.36642C4.57875 7.36642 5.5 6.13046 5.5 4.61985C5.5 3.10924 4.57875 1.87328 3.4375 1.87328ZM9.96875 6.21286C9.3775 6.91323 8.56625 7.33895 7.645 7.36642C8.01625 7.88826 8.25 8.51997 8.25 9.20662V10.113H11V7.83333C11 7.11923 10.5737 6.50125 9.96875 6.19913V6.21286ZM1.03125 7.58614C0.42625 7.88826 0 8.50624 0 9.22035V11.5H6.875V9.22035C6.875 8.50624 6.44875 7.88826 5.84375 7.58614C5.225 8.31398 4.38625 8.7397 3.4375 8.7397C2.48875 8.7397 1.65 8.30025 1.03125 7.58614Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingManagement);
export default __webpack_public_path__ + "static/media/icon-setting-management.c6dbc3053e231901a631b4333f706447.svg";
export { ForwardRef as ReactComponent };